import { world } from '../../../../../languages';

export const localesMap = {
    AD: 'en_AD',
    AE: 'en_AE',
    AG: 'en_AG',
    AI: 'en_AI',
    AL: 'en_AL',
    AM: 'en_AM',
    AO: 'en_AO',
    AR: 'es_AR',
    AT: 'de_AT',
    AU: 'en_AU',
    AW: 'en_AW',
    AZ: 'en_AZ',
    BA: 'en_BA',
    BB: 'en_BB',
    BE: 'en_BE',
    BF: 'fr_BF',
    BG: 'en_BG',
    BH: 'ar_BH',
    BI: 'fr_BI',
    BJ: 'fr_BJ',
    BM: 'en_BM',
    BN: 'en_BN',
    BO: 'es_BO',
    BR: 'pt_BR',
    BS: 'en_BS',
    BT: 'en_BT',
    BW: 'en_BW',
    BY: 'en_BY',
    BZ: 'es_BZ',
    C2: 'zh_CN',
    CA: 'en_CA',
    CD: 'fr_CD',
    CG: 'en_CG',
    CH: 'de_CH',
    CI: 'fr_CI',
    CK: 'en_CK',
    CL: 'es_CL',
    CM: 'fr_CM',
    CN: 'zh_CN',
    CO: 'es_CO',
    CR: 'es_CR',
    CV: 'en_CV',
    CY: 'en_CY',
    CZ: 'cs_CZ',
    DE: 'de_DE',
    DJ: 'fr_DJ',
    DK: 'da_DK',
    DM: 'en_DM',
    DO: 'es_DO',
    DZ: 'ar_DZ',
    EC: 'es_EC',
    EE: 'en_EE',
    EG: 'ar_EG',
    ER: 'en_ER',
    ES: 'es_ES',
    ET: 'en_ET',
    FI: 'fi_FI',
    FJ: 'en_FJ',
    FK: 'en_FK',
    FM: 'en_FM',
    FO: 'da_FO',
    FR: 'fr_FR',
    GA: 'fr_GA',
    GB: 'en_GB',
    GD: 'en_GD',
    GE: 'en_GE',
    GF: 'en_GF',
    GI: 'en_GI',
    GL: 'da_GL',
    GM: 'en_GM',
    GN: 'fr_GN',
    GP: 'en_GP',
    GR: 'el_GR',
    GT: 'es_GT',
    GW: 'en_GW',
    GY: 'en_GY',
    HK: 'en_HK',
    HN: 'es_HN',
    HR: 'en_HR',
    HU: 'hu_HU',
    ID: 'id_ID',
    IE: 'en_IE',
    IL: 'he_IL',
    IN: 'en_IN',
    IS: 'en_IS',
    IT: 'it_IT',
    JM: 'es_JM',
    JO: 'ar_JO',
    JP: 'ja_JP',
    KE: 'en_KE',
    KG: 'en_KG',
    KH: 'en_KH',
    KI: 'en_KI',
    KM: 'fr_KM',
    KN: 'en_KN',
    KR: 'ko_KR',
    KW: 'ar_KW',
    KY: 'en_KY',
    KZ: 'en_KZ',
    LA: 'en_LA',
    LC: 'en_LC',
    LI: 'en_LI',
    LK: 'en_LK',
    LS: 'en_LS',
    LT: 'en_LT',
    LU: 'en_LU',
    LV: 'en_LV',
    MA: 'ar_MA',
    MC: 'fr_MC',
    MD: 'en_MD',
    ME: 'en_ME',
    MG: 'en_MG',
    MH: 'en_MH',
    MK: 'en_MK',
    ML: 'fr_ML',
    MN: 'en_MN',
    MQ: 'en_MQ',
    MR: 'en_MR',
    MS: 'en_MS',
    MT: 'en_MT',
    MU: 'en_MU',
    MV: 'en_MV',
    MW: 'en_MW',
    MX: 'es_MX',
    MY: 'en_MY',
    MZ: 'en_MZ',
    NA: 'en_NA',
    NC: 'en_NC',
    NE: 'fr_NE',
    NF: 'en_NF',
    NG: 'en_NG',
    NI: 'es_NI',
    NL: 'nl_NL',
    NO: 'no_NO',
    NP: 'en_NP',
    NR: 'en_NR',
    NU: 'en_NU',
    NZ: 'en_NZ',
    OM: 'ar_OM',
    PA: 'es_PA',
    PE: 'es_PE',
    PF: 'en_PF',
    PG: 'en_PG',
    PH: 'en_PH',
    PL: 'pl_PL',
    PM: 'en_PM',
    PN: 'en_PN',
    PT: 'pt_PT',
    PW: 'en_PW',
    PY: 'es_PY',
    QA: 'en_QA',
    RE: 'en_RE',
    RO: 'en_RO',
    RS: 'en_RS',
    RU: 'ru_RU',
    RW: 'fr_RW',
    SA: 'ar_SA',
    SB: 'en_SB',
    SC: 'fr_SC',
    SE: 'sv_SE',
    SG: 'en_SG',
    SH: 'en_SH',
    SI: 'en_SI',
    SJ: 'en_SJ',
    SK: 'sk_SK',
    SL: 'en_SL',
    SM: 'en_SM',
    SN: 'fr_SN',
    SO: 'en_SO',
    SR: 'en_SR',
    ST: 'en_ST',
    SV: 'es_SV',
    SZ: 'en_SZ',
    TC: 'en_TC',
    TD: 'fr_TD',
    TG: 'fr_TG',
    TH: 'th_TH',
    TJ: 'en_TJ',
    TM: 'en_TM',
    TN: 'ar_TN',
    TO: 'en_TO',
    TT: 'en_TT',
    TV: 'en_TV',
    TW: 'zh_TW',
    TZ: 'en_TZ',
    UA: 'en_UA',
    UG: 'en_UG',
    US: 'en_US',
    UY: 'es_UY',
    VA: 'en_VA',
    VC: 'en_VC',
    VE: 'es_VE',
    VG: 'en_VG',
    VN: 'en_VN',
    VU: 'en_VU',
    WF: 'en_WF',
    WS: 'en_WS',
    YE: 'ar_YE',
    YT: 'en_YT',
    ZA: 'en_ZA',
    ZM: 'en_ZM',
    ZW: 'en_ZW'
};

export const getLocale = (countryCode: string) => {
    if (localesMap[countryCode]) {
        const firstLocalePart = localesMap[countryCode].split('_')[0];

        if (firstLocalePart === world) {
            return localesMap[countryCode];
        }
    }

    return localesMap[world.toUpperCase()] || localesMap.US;
};
